function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Delivery Address
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import ErrorMessage from '../error-message/ErrorMessage';
import ToggleAddressFields from '../toggle-address-fields/ToggleAddressFields';
import Delivery from '../delivery/Delivery';
import AddressFinder from '../address-finder/AddressFinder';
import AddressComponents from '../address-components/AddressComponents';
import TextInput from '../text-input/TextInput';
import { addressDeliveryFieldsToggle, licenceDeliveryAddressFullName } from '../../actions';
import { FIELDS } from '../../data/Data';
import './DeliveryAddress.scss';
import Info from '../info/Info';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LABEL = 'Address';
const NAME = 'licenceDeliveryAddress';
const SECTION = 'licence-details';
export class DeliveryAddress extends React.Component {
  constructor(props) {
    super(props);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        focus
      } = this.state;
      if (focus && key === 'Enter') {
        this.toggle();
      }
    });
    /**
     * Toggle the address components
     */
    _defineProperty(this, "toggle", () => {
      const {
        addresses,
        toggle
      } = this.props;
      toggle(!addresses.addressDeliveryFieldsToggle);
    });
    /**
     * toggle focus
     */
    _defineProperty(this, "focus", () => {
      this.setState({
        focus: !this.state.focus
      });
    });
    this.state = {
      focus: false
    };
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  render() {
    const {
      addresses,
      bugsnagClient,
      licenceDeliveryAddressFullName,
      names
    } = this.props;
    const {
      addressDeliveryFieldsToggle,
      licenceDeliveryAddress
    } = addresses;
    const {
      error
    } = licenceDeliveryAddress;
    const errorMessage = `<span>There is a problem with your delivery address. ${addressDeliveryFieldsToggle ? '' : '<span>Please <span >enter it manually</span></span>'}</span>`;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Info, {
        info: "Once your application is reviewed and approved, your permit will be dispatched within 3 business days in metropolitan areas. It may take longer for public holidays and regional delivery subject to Australia Post delivery times. You will receive a confirmation email with tracking details."
      }), /*#__PURE__*/_jsxs("div", {
        className: "DeliveryAddress",
        children: [/*#__PURE__*/_jsx(TextInput, {
          autoComplete: "off",
          handleChange: licenceDeliveryAddressFullName,
          onBlur: licenceDeliveryAddressFullName,
          label: "Delivery name (if different to licence name)",
          name: "licenceDeliveryAddressFullName",
          section: SECTION,
          values: names
        }), /*#__PURE__*/_jsx(Delivery, {}), /*#__PURE__*/_jsx(AddressFinder, {
          bugsnagClient: bugsnagClient,
          label: LABEL,
          name: NAME,
          section: SECTION
        }), /*#__PURE__*/_jsx(AddressComponents, {
          label: LABEL,
          name: NAME,
          section: SECTION
        }), /*#__PURE__*/_jsx(ToggleAddressFields, {
          name: NAME
        }), /*#__PURE__*/_jsx("div", {
          className: "DeliveryAddress-error",
          onClick: this.toggle,
          role: "button",
          tabIndex: "0",
          onFocus: this.focus,
          onBlur: this.focus,
          children: /*#__PURE__*/_jsx(ErrorMessage, {
            message: errorMessage,
            error: error
          })
        })]
      })]
    });
  }
}
_defineProperty(DeliveryAddress, "defaultProps", {
  addresses: {
    ...FIELDS.addresses
  },
  names: {
    ...FIELDS.names
  }
});
const mapStateToProps = ({
  addresses,
  names
}) => {
  return {
    addresses,
    names
  };
};
const mapDispatchToProps = dispatch => {
  return {
    licenceDeliveryAddressFullName: value => {
      dispatch(licenceDeliveryAddressFullName(value));
    },
    toggle: value => {
      dispatch(addressDeliveryFieldsToggle(value));
    }
  };
};
const VisibleDeliveryAddress = connect(mapStateToProps, mapDispatchToProps)(DeliveryAddress);
export default VisibleDeliveryAddress;